export enum BatchProcessFieldName {
	BSc_Notes = 'BSc_Notes',
	BSc_Status = 'BSc_Status',
	BSc_Exit = 'BSc_Exit',
	BSd_Batch_Created = 'BSd_Batch_Created',
	BSf_Receipted_Amt = 'BSf_Receipted_Amt',
	BSf_Refund_Amt = 'BSf_Refund_Amt',
	BSf_Allocated_Amt = 'BSf_Allocated_Amt',
	BSf_Correction_Amt = 'BSf_Correction_Amt',
	BSi_Identity = 'BSi_Identity',
	BSl_Batch_Reference = 'BSl_Batch_Reference',
	BSl_Receipt_Ref = 'BSl_Receipt_Ref',
	BSl_Orig_Receipt_Ref = 'BSl_Orig_Receipt_Ref',
	BSl_Master_Batch_Ref = 'BSl_Master_Batch_Ref',
	BSn_US_ID_Locked = 'BSn_US_ID_Locked',
	BSz_Batch_Code = 'BSz_Batch_Code',
	BSz_Batch_Group = 'BSz_Batch_Group',
	BSz_Description = 'BSz_Description',
	BSz_Fund = 'BSz_Fund',
	BSz_Member = 'BSz_Member',
	BSz_Payroll = 'BSz_Payroll',
	BSl_Job_Ref = 'BSl_Job_Ref',
	BSz_Job_Queue = 'BSz_Job_Queue',
	DT_RowId = 'DT_RowId',
	ZYl_Batch_Error_Level = 'ZYl_Batch_Error_Level',
	ZYc_Master_Child_Indicator = 'ZYc_Master_Child_Indicator',
	ZYl_Batch_Progress_Current = 'ZYl_Batch_Progress_Current',
	ZYl_Batch_Progress_Total = 'ZYl_Batch_Progress_Total',
	ZYz_Batch_Progress_Status = 'ZYz_Batch_Progress_Status',
	ZYz_IsRestoreBatchAllowed = 'ZYz_IsRestoreBatchAllowed',
	ZYz_IsProcessBatchAllowed = 'ZYz_IsProcessBatchAllowed',
	ZYz_Traffic_Lights = 'ZYz_Traffic_Lights',
	ZYf_Allocated_Amt = 'ZYf_Allocated_Amt',
	ZYf_Unallocated = 'ZYf_Unallocated',
	ZYi_Exit_Result_Report_Identity = 'ZYi_Exit_Result_Report_Identity',
	ZYc_Job_Priority = 'ZYc_Job_Priority',
	ZYv_Correlation_ID = 'ZYv_Correlation_ID',
}

/**
 * This should correspond to the Java class:
 * au.com.finsyn.acuritywebserver.core.api.BatchProgressStatus
 */
export enum BatchProgressStatus {
	AWAITS_AUTHORISATION = 'AWAITS_AUTHORISATION',
	CANCELLED = 'CANCELLED',
	COMPLETED = 'COMPLETED',
	ERROR = 'ERROR',
	IN_PROGRESS_WITH_ERROR = 'IN_PROGRESS_WITH_ERROR',
	IN_PROGRESS = 'IN_PROGRESS',
}

export interface BatchProcess {
	BSc_Notes: string;
	BSc_Status: string;
	BSd_Batch_Created: string;
	BSi_Identity: number;
	BSl_Batch_Reference: number;
	BSl_Master_Batch_Ref: number;
	BSl_Receipt_Ref: number;
	BSl_Orig_Receipt_Ref: number;
	BSz_Batch_Code: string;
	BSz_Batch_Group: string;
	BSz_Description: string;
	BSz_Fund: string;
	BSz_Member: string;
	BSf_Allocated_Amt: number;
	BSf_Correction_Amt: number;
	BSf_Receipted_Amt: number;
	BSf_Refund_Amt: number;
	DT_RowId: string;
	ZYl_Batch_Error_Level: number;
	ZYc_Master_Child_Indicator: string;
	ZYl_Batch_Progress_Current: number;
	ZYl_Batch_Progress_Total: number;
	ZYz_Batch_Progress_Status: BatchProgressStatus;
	ZYz_IsRestoreBatchAllowed: string;
	ZYz_IsProcessBatchAllowed: string;
}

export interface BatchCode {
	group: string;
	code: string;
	description: string;
}
